import { ShieldAlert } from 'lucide-react';

import { cn } from '../lib/cn.js';

interface SuperAdminBannerProps {
  /** Org name being viewed; absent when the super-admin is on their own console. */
  viewingOrgName?: string;
  /** Optional handler to exit "view-as" mode and return to the platform console. */
  onExit?: () => void;
  className?: string;
}

/**
 * Sticky 28px banner described in DESIGN_SYSTEM.md §14. Renders above all
 * other chrome whenever a super-admin session is active. There is no
 * dismiss control — visibility is the point.
 */
export function SuperAdminBanner({ viewingOrgName, onExit, className }: SuperAdminBannerProps) {
  return (
    <div
      role="region"
      aria-label="Super-admin mode"
      className={cn(
        'sticky top-0 z-50 flex h-7 items-center justify-between gap-3 px-4',
        'bg-admin-banner-bg text-admin-banner-fg text-xs font-medium',
        className,
      )}
    >
      <span className="inline-flex items-center gap-2">
        <ShieldAlert className="h-3.5 w-3.5" aria-hidden />
        {viewingOrgName ? (
          <span>
            Super-admin mode — viewing <strong className="font-semibold">{viewingOrgName}</strong>
          </span>
        ) : (
          <span>Super-admin console</span>
        )}
      </span>
      {viewingOrgName && onExit ? (
        <button
          type="button"
          onClick={onExit}
          className="text-admin-banner-fg/80 underline-offset-2 hover:underline"
        >
          Exit view-as
        </button>
      ) : null}
    </div>
  );
}
